// extracted by mini-css-extract-plugin
export default {"layout-item":"LayoutsList_layout-item__mL0VH","layoutItem":"LayoutsList_layout-item__mL0VH"};